@let disabled = store.disabledSg();
@let label = store.labelSg();
@let error = store.errorSg();
@let loading = store.loadingSg();
@let selectedItem = store.selectedItemSg();
@let required = store.requiredSg();
@let placeholder = store.placeholderSg();

<div class="atn-ds-input-field">
  @if (label) {
    <span
      class="atn-ds-input-field__label"
      data-test-id="atn-select-single-label"
    >
      {{ label }}
      @if (required) {
        *
      }
    </span>
  }
  <div
    class="atn-ds-single-select"
    data-test-id="atn-select-single"
    [class.atn-ds-single-select--disabled]="disabled"
    [class.atn-ds-single-select--slim]="store.isSlimSg()"
    [class.atn-ds-single-select--warning-border]="error"
    (click)="!disabled && store.patchState({ isOpen: true })"
    #overlayOrigin
  >
    <div
      data-test-id="atn-select-single-input-value"
      class="atn-ds-single-select__label"
      [class.atn-ds-single-select__label--disabled]="disabled"
      [class.atn-ds-single-select__label--placeholder]="!selectedItem"
    >
      {{ selectedItem?.label ?? placeholder }}
    </div>
    <!-- ----------------------------- Loader Icon ----------------------------- -->
    <div class="atn-ds-single-select__icons">
      @if (loading) {
        <i
          data-test-id="atn-select-single-loader"
          class="atn-icon atn-waiting atn-blue"
        ></i>
      }
      <i
        class="fas fa-sort-down atn-ds-single-select__open-icon"
        [class.atn-ds-single-select__open-icon--disabled]="disabled"
      ></i>
    </div>
  </div>
  <!-- ---------------------------- Error Banner ----------------------------- -->
  <!-- NOTE: Due to the structure of HTML, we cannot use if-else statements directly.
  Therefore, we should not display the error until loading is complete. -->
  @if (error && !loading) {
    <div
      class="atn-ds-single-select__error"
      data-test-id="atn-select-single-error-banner"
    >
      <div class="atn-ds-single-select__error-info">
        <i class="atn-icon default atn-warning-triangle"></i>
        <span data-test-id="atn-select-single-error-message">{{ error }}</span>
      </div>
      <div>
        @if (refetch.observed) {
          <i
            data-test-id="atn-select-single-refetch-button"
            class="atn-icon atn-reset atn-dark"
            (click)="refetch.emit()"
          ></i>
        }
      </div>
    </div>
  }
</div>

<atn-ds-single-overlay [origin]="overlayOrigin" />
